import { Box, Modal, Grid, Button, Typography } from '@mui/material';
import { useContext } from 'react';
import ReviewContext from 'src/store/review-page-context';
import formatter from '../util/currencyFormatter';
import { QUALIFYING_TAX_AMNT } from 'src/constants/global';
import { colors } from 'src/styles/theme';
/**
 * The style object for the modal container.
 */
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: `2px solid ${colors.primary.dark}`,
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  minWidth: '300px',
};

/**
 * The ExemptionNotificationModal component displays a modal to the user
 * to ask if they want to be considered for tax exemption status.
 *
 * @param {Object} props - The props object.
 * @returns {JSX.Element} The rendered ExemptionNotificationModal component.
 */
const ExemptionNotificationModal = () => {
  const SPACING = 2;
  const { exemptionNotificationModal, itemizeModal, reviewInfo, exemptionModal } =
    useContext(ReviewContext);
  const { review } = reviewInfo;
  const { exemptionNotificationModalController } = exemptionNotificationModal;
  const { itemizeModalController } = itemizeModal;
  const { exemptionModalController } = exemptionModal;

  /**
   * Handles the event when the user clicks the "Yes" button.
   *
   * If the value of `bypassItemization` is 'N', the exemption modal is opened
   * and the exemption notification modal is closed.
   * If the value of `bypassItemization` is 'Y', the itemize modal is opened.
   */
  const handleYes = () => {
    const { bypassItemization } = review.updatedInfo;
    if (['N', 'X'].includes(bypassItemization)) {
      exemptionModalController.openModal();
      exemptionNotificationModalController.closeModal();
    } else if (bypassItemization === 'Y') {
      itemizeModalController.openModal();
    }
  };

  return (
    <>
      <Modal open={exemptionNotificationModalController.open}>
        <Box sx={modalStyle}>
          <Grid container sx={{ justifyContent: 'center', mb: '1rem' }}>
            <Grid item>
              <Typography component="h2">
                Your account might be qualified for a tax exemption due to being below the{' '}
                {formatter.format(QUALIFYING_TAX_AMNT)}. Would you like it to be considered for tax
                exemption status?{' '}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={SPACING} sx={{ justifyContent: 'center' }}>
            <Grid item>
              <Button
                data-cy="exempt-no"
                type="submit"
                variant="outlined"
                onClick={exemptionNotificationModalController.closeModal}
              >
                No
              </Button>
            </Grid>
            <Grid item>
              <Button data-cy="exempt-yes" type="submit" variant="contained" onClick={handleYes}>
                Yes
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default ExemptionNotificationModal;
